import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { ConnectedOmnibox } from '../../omnibox/components/ConnectedOmnibox';
import { KeydownOutsideDetector } from '../../ts/helpers/KeydownOutsideDetector';
import { Keys } from '../../ts/helpers/Keys';
import { MousedownOutsideDetector } from '../../ts/helpers/MousedownOutsideDetector';
import { vizHeaderSearchButtonImgTestId } from '../layout/PageHeaderSearch';
import { vizHeaderSearchOpenButtonTestId } from '../layout/VizViewerPageHeader';

export class HeaderSearchBox extends React.Component<HeaderSearchBox.Props, HeaderSearchBox.State> {

  static displayName = 'HeaderSearchBox';

  static element = React.createFactory(HeaderSearchBox);

  static minResultsWidth = 350;

  private static nextId = 1;


  private detachMousedownOutsideDetector: () => void;
  private detachKeyboardOutsideDetector: () => void;


  public render() {
    return React.createElement(ConnectedOmnibox, {
      closedWithFocus: () => this.props.searchClosed(null),
      closedWithoutFocus: () => this.props.searchClosedWithoutNeedingFocus(null),
      shouldOpenWithFocusInSearchTextbox: this.props.letSearchBoxHasFocus,
      isSearchInputBoxActive: this.props.isSearchInputBoxActive,
    });
  }

  public componentDidMount() {
    const searchClosedFn = (downEvent: JQueryEventObject) => {
      const targetElement = downEvent && $(downEvent.target);
      if (targetElement) {

        const isCloseIcon = targetElement.attr('data-tb-test-id') === vizHeaderSearchOpenButtonTestId
          || targetElement.attr('data-tb-test-id') === vizHeaderSearchButtonImgTestId;

        if (isCloseIcon) {  // return focus to search button if closed using the X button
          this.props.searchClosed(downEvent);
        }
      }

      this.props.searchClosedWithoutNeedingFocus(downEvent);
    };

    // these catch the case when the search text box is open, without the omnibox open (no search term)
    // and a user clicks outside the search box or activates a menu outside the search box. In that case
    // we don't want the focus to return to the search buttons but we want to close the text boxm unless
    // the user clicked on the X (close) button.
    const id = '' + HeaderSearchBox.nextId++;
    this.detachMousedownOutsideDetector = MousedownOutsideDetector.attach(
      $(ReactDOM.findDOMNode(this) as HTMLElement),
      (element: JQuery) => id,
      (downEvent: JQueryEventObject) => searchClosedFn(downEvent));

    this.detachKeyboardOutsideDetector = KeydownOutsideDetector.attach(
      $(ReactDOM.findDOMNode(this) as HTMLElement),
      (element: JQuery) => id,
      (downEvent: JQueryEventObject) => searchClosedFn(downEvent),
      [Keys.Space, Keys.Enter, Keys.Escape]);
  }

  public componentWillUnmount() {
    this.detachMousedownOutsideDetector();
    this.detachKeyboardOutsideDetector();
  }

}

export module HeaderSearchBox {

  export interface Props {
    omniboxOpenWidth: number;
    searchClosed: (event: BaseJQueryEventObject) => void;
    searchClosedWithoutNeedingFocus: (event: BaseJQueryEventObject) => void;
    letSearchBoxHasFocus: boolean;
    isSearchOpen: boolean;
    isSearchInputBoxActive: (isActive: boolean) => void;
  }

  export interface State {
  }

}
